var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5196 12.2731C23.5196 11.4222 23.4433 10.604 23.3014 9.8186H11.9998V14.4604H18.4579C18.1797 15.9604 17.3342 17.2312 16.0633 18.0821V21.093H19.9415C22.2105 19.004 23.5196 15.9276 23.5196 12.2731Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 23.9999C15.2398 23.9999 17.9562 22.9254 19.9416 21.0927L16.0635 18.0818C14.9889 18.8018 13.6144 19.2272 11.9999 19.2272C8.87446 19.2272 6.22904 17.1164 5.28541 14.28H1.27637V17.3891C3.25089 21.3109 7.30903 23.9999 11.9999 23.9999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28539 14.2798C5.0454 13.5599 4.90904 12.7908 4.90904 11.9999C4.90904 11.209 5.0454 10.4399 5.28539 9.7199V6.61084H1.27635C0.463631 8.23082 0 10.0635 0 11.9999C0 13.9362 0.463631 15.7689 1.27635 17.3889L5.28539 14.2798Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.77292C13.7617 4.77292 15.3435 5.37836 16.5871 6.56744L20.0289 3.12566C17.9507 1.18932 15.2344 0.000244141 11.9999 0.000244141C7.30903 0.000244141 3.25089 2.6893 1.27637 6.61108L5.28541 9.72013C6.22904 6.8838 8.87446 4.77292 11.9999 4.77292Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.1298931fbcd18dd13f8efccc8892700a.svg";
export { ForwardRef as ReactComponent };